import { render } from "./panelMs.vue?vue&type=template&id=2137f20d"
import script from "./panelMs.vue?vue&type=script&lang=js"
export * from "./panelMs.vue?vue&type=script&lang=js"

import "./panelMs.vue?vue&type=style&index=0&id=2137f20d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__